import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

import { PENDING, SUCCESS } from '../../../design-system/constants';
import { Loader } from '../../../design-system/Loader';
import {
    getAllMessageTemplatesRequest,
    patchMessageTemplateRequest,
} from '../../../resources/message-template/actions';
import {
    getMessageTemplateById,
    getMessageTemplateStatus,
    patchMessageTemplateStatus,
} from '../../../resources/message-template/selectors';
import { useAppDispatch, useAppSelector } from '../../../shared/redux';

import s from '../MessageTemplates.module.css';

import { Form } from './Form';

export const MessageTemplateEdit = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { messageTemplateId } = useParams() as { messageTemplateId: string };
    const messageTemplate = useAppSelector((state) =>
        getMessageTemplateById(state, messageTemplateId),
    );
    const getStatus = useAppSelector(getMessageTemplateStatus);
    const patchStatus = useAppSelector((state) =>
        patchMessageTemplateStatus(state, messageTemplateId),
    );
    useEffect(() => {
        dispatch(getAllMessageTemplatesRequest());
    }, [dispatch]);

    const hasTemplate = typeof messageTemplate !== 'undefined' || getStatus === SUCCESS;
    const displayLoader = typeof messageTemplate === 'undefined' && getStatus === PENDING;
    const isSubmitting = patchStatus === PENDING;
    const submitUpdateMessageTemplate = ({ title, content }: { title: string; content: string }) =>
        dispatch(
            patchMessageTemplateRequest(
                {
                    ...messageTemplate,
                    title,
                    content,
                },
                () => navigate('/templates/list'),
            ),
        );

    if (typeof messageTemplate === 'undefined' && getStatus === SUCCESS) {
        return <Navigate to="/templates/list" replace />;
    }

    return (
        <div className={s.messageTemplateFormContainer}>
            <h1 className={s.title}>
                <FormattedMessage id="templates.bo.edit" />
            </h1>
            {hasTemplate && (
                <Form
                    initialTitle={messageTemplate.title}
                    initialContent={messageTemplate.content}
                    submit={submitUpdateMessageTemplate}
                    isSubmitting={isSubmitting}
                />
            )}
            {displayLoader && (
                <div className={s.centerContainer}>
                    <Loader className={s.loader} />
                </div>
            )}
        </div>
    );
};
